import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import Breadcrumbs from './Breadcrumbs';
import './Navbar.css';

type NavbarProps = {
  onToggleSidebar?: () => void;
};

const Navbar: React.FC<NavbarProps> = ({ onToggleSidebar }) => {
  return (
    <nav className="app-navbar">
      <div className="app-navbar-left">
        <button
          className="app-navbar-menu"
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <FontAwesomeIcon icon={faBars} />
          <span className="app-navbar-home">Home</span>
        </button>

        <Breadcrumbs inline className="app-navbar-breadcrumbs" />
      </div>

      <div className="app-navbar-right">{/* 右侧区域（可留空） */}</div>
    </nav>
  );
};

export default Navbar;
